"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMarkdownParser = void 0;
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _markdownIt = _interopRequireDefault(require("markdown-it"));
const defaultRender = (tokens, idx, options, env, self) => self.renderToken(tokens, idx, options);

/**
 * Markdown parser set to open links in a new tab *unless* it's a `tel:` link
 * @returns {markdownParser}
 */
const buildMarkdownParser = () => {
  const md = new _markdownIt.default();
  const render = md.renderer.rules.link_open || defaultRender;
  md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
    const aIndex = tokens[idx].attrIndex('target');
    const href = tokens[idx].attrGet('href') || '';
    const isPhoneLink = (0, _indexOf.default)(href).call(href, 'tel:') != -1;
    if (!isPhoneLink) {
      if (aIndex < 0) {
        tokens[idx].attrPush(['target', '_blank']);
      } else {
        tokens[idx].attrs[aIndex][1] = '_blank';
      }
    }
    return render(tokens, idx, options, env, self);
  };
  return md;
};
exports.buildMarkdownParser = buildMarkdownParser;